module.exports = __webpack_public_path__ + "img/title-bg.84f1beeb.png";